package com.appsyde.shared.presentation.screen.component.history

import androidx.compose.runtime.Composable
import com.appsyde.shared.presentation.style.style.AppStylesHistory
import org.jetbrains.compose.web.dom.*

@Composable
fun HistoryPresentSeparator() {
    Div(attrs = { classes(AppStylesHistory.historySeparatorWrap) }) {
        Div(attrs = { classes(AppStylesHistory.historySeparatorLine) })
        Span(attrs = { classes(AppStylesHistory.historySeparatorText) }) { Text("Message en cours") }
        Div(attrs = { classes(AppStylesHistory.historySeparatorLine) })
    }
}
